<div class="mb-3">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <textarea
    class="form-control"
    [class.is-invalid]="hasError"
    [placeholder]="placeholder"
    [rows]="rows"
    [disabled]="isDisabled"
    [readonly]="readonly"
    [attr.maxlength]="maxLength ?? null"
    [value]="value"
    (input)="handleInput($event)"
    (blur)="handleBlur()"
  >
  </textarea>

  <div class="d-flex justify-content-between mt-1">
    <small *ngIf="helpText && !hasError" class="form-text text-muted">{{
      helpText
    }}</small>
    <small *ngIf="maxLength" class="form-text text-muted ms-auto">
      {{ charCount }}/{{ maxLength }}
    </small>
  </div>

  <is-form-error *ngIf="control" [control]="control"></is-form-error>
</div>
